// ===== Services =====

import {
    isAnnotationComment,
}                                       from '.';

// ===== Interfaces =====

import {
    IAnnotationItem,
    IAnnotationCommentTombstoneItem,
}                                       from '../interfaces';

const isAnnotationCommentTombstone = (
    annotation: IAnnotationItem,
): annotation is IAnnotationCommentTombstoneItem => (
    isAnnotationComment(annotation)
    && annotation.deleted.deleted
);

export default isAnnotationCommentTombstone;
